module.exports = __webpack_public_path__ + "static/media/chaliceCorrect.dc1404f6.png";